import React, { useEffect, useState } from 'react';
import useTranslation from '../../../../hooks/useTranslation';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPageAuth } from '../../../../utils/page-auth';
import { Helmet } from 'react-helmet';
import Notification from '../../../../components/Notification/Notification';
import useSchemaInAppRankSystem from '../../../../schema/table-schema/useSchemaInAppRankSystem';
import { rankSystemListRequest, rankSystemUpdateRequest } from '../../../../redux/actions/app/inAppRankSystemActions';
import BOTableInAppRankSystem from '../../../../components/Tables/BOTableInAppRankSystem';
import BOTable from "../../../../components/Tables/BOTable";
import history from "../../../../utils/history";

function InAppRankSystemMain() {
  // -- component const --//
  // 페이지 제목
  const title = 'admin.app.fixAppData.inAppRankSystem.title'; // '인앱 랭킹 시스템 관리';

  const { t } = useTranslation();
  const { schema } = useSchemaInAppRankSystem();

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authReducer.user);

  // -- state --//
  const [readOnly, setReadOnly] = useState(true);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 테이블
  const [tBody, setTbody] = useState();
  const [totalCount, setTotalCount] = useState(0);

  // 로딩
  const [isLoading, setIsLoading] = useState(false);

  // -- func & handler --//
  const fetchList = () => {
    setIsLoading(true);

    dispatch(
      rankSystemListRequest({
        callback: (data) => {
          console.log('요청 결과: ', data);
          setTbody(data?.list);
          setTotalCount(data?.list?.length);
          setIsLoading(false);
        },
        error: (e) => {
          console.error('Error:', e);
          setNotificationMessage(e.toString());
          setShowNotification(true);
        },
      }),
    );
  };

  const handleRowChange = (value, row) => {
    // 필요한 경우 여기서 추가 로직을 수행할 수 있다.
    // 예: 유효성 검사 등
  };

  function handleRowClick(row) {

      console.log("row click")
      console.log(row);
      if (row?.param1) {
          history.push({
              pathname: '/admin/app/fixAppData/inAppRankSystem/update',
              row: {
                  lastRank : row.lastRank,
                  rankDetail : row.rankDetail,
                  rankType : row.rankType,
                  settingNo : row.settingNo,
                  targetType: row.targetType,
                  withoutTarget : row.withoutTarget,
              }
          });
      }
  }


  // -- react hooks --//
  useEffect(() => {
    getUserPageAuth(user).then((res) => setReadOnly(res));
  }, [user]);

  useEffect(() => {
    fetchList();
  }, []);

  // -- render --//
  return (
    <div className="page">
      <Helmet>
        <title>{t(title)}</title>
      </Helmet>

      <section className={"topSection"}>
          <div className="leftSection">
              <p className="titleText">
                  {t(title)}
                  {readOnly ? '(읽기전용)' : ''}
              </p>
          </div>

          <div className={"rightSection"}>
          <button
              className={"outlineBtn"}
              onClick={() => { fetchList() }}
          >
              List 갱신
          </button>
      </div>

      </section>

      <div className="spaceDiv10"/>

      <section
          className={"rightSection"}
      >
          전체 {totalCount?.toLocaleString()} 항목
      </section>

      <div className="spaceDiv10"/>
      <div className="spaceDiv10"/>
      <div className="spaceDiv10"/>


      <BOTable
        className={'user-rank-table'}
        schema={schema}
        rows={tBody}
        loading={isLoading}
        onClick={handleRowClick}
        maxHeight={"calc(100vh - 200px)"}
      />

      <div className="spaceDiv10"/>

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}
    </div>
  );

}

export default InAppRankSystemMain;
